import { render, staticRenderFns } from "./Crawlingmanager.vue?vue&type=template&id=6428da30&scoped=true"
import script from "./Crawlingmanager.vue?vue&type=script&lang=js"
export * from "./Crawlingmanager.vue?vue&type=script&lang=js"
import style0 from "./Crawlingmanager.vue?vue&type=style&index=0&id=6428da30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6428da30",
  null
  
)

export default component.exports